import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const heroSlides = [
  {
    id: 'v003',
    title: '欢乐集结号',
    subtitle: '年度最受欢迎综艺 · 欢笑与感动并存',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20dramatic%20warm%20stage%20lighting%20and%20confetti%20falling%2C%20energetic%20hosts%20on%20a%20grand%20modern%20TV%20studio%20set%2C%20cheerful%20vibrant%20atmosphere%2C%20professional%20broadcast%20photography%2C%20golden%20and%20amber%20color%20palette%2C%20wide%20cinematic%20composition&width=1800&height=900&seq=hero-slide-01&orientation=landscape',
    category: '综艺',
    categorySlug: 'zy',
  },
  {
    id: 'v001',
    title: '山河故人',
    subtitle: '跨越三十年的情感史诗 · 时代变迁中的人性光芒',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20cinematic%20landscape%20with%20misty%20mountains%20at%20sunset%2C%20warm%20golden%20light%20piercing%20through%20clouds%2C%20small%20figures%20on%20a%20winding%20mountain%20path%2C%20dramatic%20and%20emotional%20atmosphere%2C%20film%20cinematography%20style%2C%20rich%20earthy%20tones&width=1800&height=900&seq=hero-slide-02&orientation=landscape',
    category: '剧情',
    categorySlug: 'jq',
  },
  {
    id: 'v011',
    title: '星光音乐会',
    subtitle: '星空下的音乐盛宴 · 极致视听享受',
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20night%20concert%20with%20brilliant%20stage%20lights%20illuminating%20a%20large%20enthusiastic%20crowd%20under%20a%20starry%20sky%2C%20colorful%20light%20beams%2C%20festival%20atmosphere%2C%20magical%20and%20vibrant%20energy%2C%20professional%20event%20photography%2C%20golden%20and%20warm%20color%20palette&width=1800&height=900&seq=hero-slide-03&orientation=landscape',
    category: '综艺',
    categorySlug: 'zy',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[current];

  return (
    <section className="relative h-[500px] md:h-[650px] w-full overflow-hidden">
      {heroSlides.map((s, index) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-4 whitespace-nowrap">
            {slide.category}
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-background-50 mb-3 font-heading tracking-wide">
            {slide.title}
          </h2>
          <p className="text-background-200 text-sm md:text-lg max-w-xl mx-auto mb-6">
            {slide.subtitle}
          </p>
          <Link
            to={`/article/${slide.id}`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-fill text-lg"></i>
            立即观看
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-8'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}